import { type IHttpApi } from '@cian/http-api';
import { type ILogger } from '@cian/logger';

import { type IUser } from '@/app/shared/types/user';

import {
  type TCianApiSiteV1GetUserDataByRequestResponse,
  fetchCianApiSiteV1GetUserDataByRequest,
} from '@/repositories/generated/shared/monolith-python/cian-api/site/v1/get-user-data-by-request';

interface IFetchUserParameters {
  subdomain: string;
}

interface IApplicationContext {
  logger: ILogger;
  httpApi: IHttpApi;
}

export async function fetchUser({ httpApi }: IApplicationContext, { subdomain }: IFetchUserParameters): Promise<IUser> {
  const userData: TCianApiSiteV1GetUserDataByRequestResponse = await fetchCianApiSiteV1GetUserDataByRequest({
    httpApi,
    config: {
      subdomain,
    },
  });

  const { user } = userData.response.data;

  if (!user) {
    throw new Error('Пользователь не найден');
  }

  return user;
}

export async function fetchUserSafe(context: IApplicationContext, parameters: IFetchUserParameters): Promise<IUser> {
  try {
    return await fetchUser(context, parameters);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Информация о пользователе' });

    return { isAuthenticated: false } as IUser;
  }
}
